<template>
  <main-layout :selectedMenu="'home'">
    <div class="videoSuccess">
      <div class="header">
        <img class="successImg" src="/static/icon_submit_done.png" alt="">
        <h3>{{$t('global.视频已提交')}}，{{$t('global.请耐心等待审核')}}</h3>
        <p class="title">{{$t('video.审核通过发布前仅发布者自己可以查看作品')}}</p>
        <ul>
          <li>
            <button @click="gobackHome">{{$t('video.回首页')}}</button>
          </li>
          <li class="showVideo">
            <button @click="goToVideo">{{$t('video.查看作品')}}</button>
          </li>
        </ul>
      </div>
      <div class="container" v-if="matchList.length">
        <h4 class="title" v-if="matchList.length">{{$t('global.推荐竞赛')}}</h4>
        <ul>
          <li v-for="item in matchList" :key="item.matchId">
            <MatchCard :item="item"/>
            <div
             @click.stop.prevent="gotoMatch(item)"
              class="operate"
            >
              {{$t('global.投稿')}}
            </div>
          </li>
        </ul>
      </div>
    </div>
    <PerfectInformation
      @closeVisible="step=0"
      @goToStep="goToNextStep"
      :step="step"
      :matchId="selectMatchId"
      v-if="step!==0"
      :isInternational="selectMatchIsInternational"
    />
  </main-layout>
</template>
<script>
import MainLayout from "@/layouts/MainLayout";
import MatchCard from "@/components/match/matchCard";
import "./style/videoSuccess.css";
import PerfectInformation from "@/pages/dialog/PerfectInformation";
export default {
  metaInfo() {
    return {
      title: this.$t("global.视频") + " | MANA"
    };
  },
  components: {
    MainLayout,
    MatchCard,
    PerfectInformation
  },
  data() {
    return {
      matchList: [],
      videoId: null,
      step: 0,
      peopleMessage: {},
      selectMatchId: null,
      selectMatchIsInternational: null
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.peopleMessage = this.$store.state.peopleMessage;
      this.videoId = this.$route.params.videoId;
      this.getMatchList();
    },
    gotoMatch(item) {
      if (item.type == 1) {
        let routeData = this.$router.resolve({
          path: "/match/" + item.url + '/enter',
        });
        window.open(routeData.href, "_blank");
      }
      if (item.type == 2) {
        window.open(item.url, "_blank");
      }
    },
    getMatchList() {
      const url = `/api/match/getRecommendMatch?videoId=${this.videoId}`;
      this.$http.get(url).then(res => {
        this.matchList = res.data.list;
      });
    },
    gobackHome() {
      this.$router.push("/");
    },
    goToVideo() {
      // this.$router.push(`/video/detail?id=${this.videoId}`);
      this.$router.push("/manageVideo");
      // this.step = 1;
    },
    contribute(id, isInternational) {
      this.selectMatchId = id;
      this.selectMatchIsInternational = isInternational;
      const url = `/api/match/user/checkIsSelfImprovement?userId=${
        this.peopleMessage.userId
      }&matchId=${id}`;
      this.$http.post(url).then(res => {
        if (res.code === "OK") {
          this.$router.push(`/matchSupplement/${id}/${this.videoId}`);
        } else {
          this.step = 1;
        }
      });
    },
    goToNextStep() {
      if (this.step === 1) {
        this.$router.push(
          `/matchSupplement/${this.selectMatchId}/${this.videoId}`
        );
      }
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/pages/my/video/VideoSuccess.vue